import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// other libraries
import { IonicModule } from '@ionic/angular';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxWebstorageModule } from 'ngx-webstorage';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CodeInputModule } from 'angular-code-input';
import { ModalDialogModule } from 'ngx-modal-dialog';
import { AlertModule, AlertConfig } from 'ngx-bootstrap/alert';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDropdownModule, BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

// pipes
import { TimeAgoExtendsPipe, SafeUrlPipe, FormatTimePipe, ThreedFormatTimePipe, Thai2d3dPhonePipe1, TwodSetFormatPipe, TwodValFormatPipe, UsernameFormatPipe, Thai2d3dPhonePipe2, Thai2d3dPhonePipe3, Thai2d3dPhonePipe4, Thai2d3dPhonePipe5, SerialNumberPipe, DisabledImagePipe } from './pipes/common.pipe';
import { DatePipe } from '@angular/common';

// components
import { AppNavigationBarComponent } from './components/app-navigation-bar/app-navigation-bar.component';
import { AppLanguagePickerComponent } from './components/app-language-picker/app-language-picker.component';
import { AppEmojiPickerComponent } from './components/app-emoji-picker/app-emoji-picker.component';
import { AppSplashScreenAdsComponent } from './components/app-splash-screen-ads/app-splash-screen-ads.component';
import { AppBannerAdsComponent } from './components/app-banner-ads/app-banner-ads.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { AppPhonePickerComponent } from './components/app-phone-picker/app-phone-picker.component';
import { AccountLoginComponent } from './components/account-login/account-login.component';
import { GameAccountLoginComponent } from './components/game-account-login/game-account-login.component';
import { NeedHelpComponent } from './components/need-help/need-help.component';
import { CountDownTimer } from './components/count-down-timer/count-down-timer.component';

// pages
import { BetSuccessComponent } from './pages/bet-success/bet-success.component';

// dialogs
import { LoginDeviceDialogComponent } from './dialogs/login-device-dialog/login-device-dialog.component';
import { BetSectionDialogComponent } from './dialogs/bet-section-dialog/bet-section-dialog.component';
import { WithdrawAlertMaintenanceComponent } from './dialogs/withdraw-alert-maintenance/withdraw-alert-maintenance.component';
import { ForgetPasswordMessageAlertComponent } from './dialogs/forget-password-message-alert/forget-password-message-alert.component';
import { TopupDialogComponent } from './dialogs/topup-dialog/topup-dialog.component';
import { SportDialogComponent } from './dialogs/sport-dialog/sport-dialog.component';
import { ForgetLoginDeviceDialogComponent } from './dialogs/forget-login-device-dialog/forget-login-device-dialog.component';
import { TopupAlertMaintenanceComponent } from './dialogs/topup-alert-maintenance/topup-alert-maintenance.component';
import { UnBetLimitModelComponent } from './dialogs/un-bet-limit-model/un-bet-limit-model.component';
import { PointtransferComponent } from './dialogs/pointtransfer/pointtransfer.component';


export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
    exports: [
        // other libraries
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        IonicModule,
        ToastrModule,
        NgxSpinnerModule,
        NgxWebstorageModule,
        ModalModule,
        CarouselModule,
        CodeInputModule,
        ModalDialogModule,
        AlertModule,
        TimepickerModule,
        TabsModule,
        BsDropdownModule,
        BsDatepickerModule,

        // pipes
        TimeAgoExtendsPipe,
        SafeUrlPipe,
        FormatTimePipe,
        ThreedFormatTimePipe,
        Thai2d3dPhonePipe1,
        TwodSetFormatPipe,
        TwodValFormatPipe,
        UsernameFormatPipe,
        Thai2d3dPhonePipe2,
        Thai2d3dPhonePipe3,
        Thai2d3dPhonePipe4,
        Thai2d3dPhonePipe5,
        SerialNumberPipe,
        DisabledImagePipe,

        // components
        AppNavigationBarComponent,
        AppLanguagePickerComponent,
        AppEmojiPickerComponent,
        AppSplashScreenAdsComponent,
        AppBannerAdsComponent,
        AppHeaderComponent,
        AppPhonePickerComponent,
        AccountLoginComponent,
        GameAccountLoginComponent,
        NeedHelpComponent,
        CountDownTimer,

        // pages
        BetSuccessComponent,

        // dialogs
        LoginDeviceDialogComponent,
        BetSectionDialogComponent,
        WithdrawAlertMaintenanceComponent,
        ForgetPasswordMessageAlertComponent,
        TopupDialogComponent,
        SportDialogComponent,
        ForgetLoginDeviceDialogComponent,
        TopupAlertMaintenanceComponent,
        UnBetLimitModelComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        IonicModule,
        ToastrModule.forRoot(),
        NgxSpinnerModule,
        NgxWebstorageModule.forRoot(),
        ModalModule.forRoot(),
        CarouselModule,
        CodeInputModule,
        ModalDialogModule,
        AlertModule,
        TimepickerModule.forRoot(),
        TabsModule.forRoot(),
        BsDropdownModule,
        BsDatepickerModule.forRoot()
    ],
    declarations: [
        // pipes
        TimeAgoExtendsPipe,
        SafeUrlPipe,
        FormatTimePipe,
        ThreedFormatTimePipe,
        Thai2d3dPhonePipe1,
        TwodSetFormatPipe,
        TwodValFormatPipe,
        UsernameFormatPipe,
        Thai2d3dPhonePipe2,
        Thai2d3dPhonePipe3,
        Thai2d3dPhonePipe4,
        Thai2d3dPhonePipe5,
        SerialNumberPipe,
        DisabledImagePipe,

        // components
        AppNavigationBarComponent,
        AppLanguagePickerComponent,
        AppEmojiPickerComponent,
        AppSplashScreenAdsComponent,
        AppBannerAdsComponent,
        AppHeaderComponent,
        AppPhonePickerComponent,
        AccountLoginComponent,
        GameAccountLoginComponent,
        NeedHelpComponent,
        CountDownTimer,

        // pages
        BetSuccessComponent,

        // dialogs
        LoginDeviceDialogComponent,
        BetSectionDialogComponent,
        WithdrawAlertMaintenanceComponent,
        ForgetPasswordMessageAlertComponent,
        TopupDialogComponent,
        SportDialogComponent,
        ForgetLoginDeviceDialogComponent,
        TopupAlertMaintenanceComponent,
        UnBetLimitModelComponent,
        PointtransferComponent
    ],
    providers: [
        BsModalService,
        DatePipe,
        AlertConfig,
        BsDropdownConfig,
        BsDatepickerConfig
    ],
    entryComponents: [
        TopupAlertMaintenanceComponent,
        BetSectionDialogComponent
    ]
})
export class SharedModule { }